import { Box, Checkbox, FormControlLabel } from '@material-ui/core'

import { LayersConfig } from '../index'
import { useStyles } from './styles'

interface LayersListProps {
  layersConfig: LayersConfig
  handleLayerChange: (layer: string, checked: boolean) => void
}

export default function LayersList({
  layersConfig,
  handleLayerChange,
}: LayersListProps) {
  const classes = useStyles()

  return (
    <Box className={classes.content}>
      {Object.entries(layersConfig).map(([layerKey, layerConfig]) => (
        <FormControlLabel
          key={layerKey}
          control={
            <Checkbox
              checked={!!layerConfig.checked}
              onChange={(e) => handleLayerChange(layerKey, e.target.checked)}
              disabled={layerConfig.disabled}
              size='medium'
              color='primary'
            />
          }
          label={layerConfig.label}
          className={classes.checkboxLabel}
        />
      ))}
    </Box>
  )
}
